<div class="not-found">
  <h1>
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    Erro 404
  </h1>
  <h3>A página <b>{{url}}</b> não foi encontrada!</h3>
  <a class="btn btn-link" (click)="back()">Voltar</a>
</div>
